module.exports = __webpack_public_path__ + "static/media/400_400_blank_screen_grey.9cb7da00.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/400_400_blank_screen_grey.svg
// module id = 246
// module chunks = 0